/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MiniBlock.vue?vue&type=template&id=50b2be6d&scoped=true"
import script from "./MiniBlock.vue?vue&type=script&lang=js"
export * from "./MiniBlock.vue?vue&type=script&lang=js"
import style0 from "./MiniBlock.vue?vue&type=style&index=0&id=50b2be6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2be6d",
  null
  
)

export default component.exports